function callForSlider(){
       var homeBannerSplide = new Splide('.home-banner-slider',{
  	wheel: false,
  	perpage: 1,
  	pagination: false,
  	autoplay: true,
    interval: 3500,
  	type: 'loop',
    arrows:false,
  });
  homeBannerSplide.mount();

    var festiveSlider = new Splide('.festive-banner-section-categorys', {
    perPage: 4,
     autoplay:true,
    interval: 3000,
  gap:'15px',
    arrows:true,
     classes: {
  arrows: 'splide__arrows festive-banner-section-category-arrow',
  arrow : 'splide__arrow festive-banner-section-category-arrow',
  prev  : 'splide__arrow--prev festive-banner-section-category-prev',
  next  : 'splide__arrow--next festive-banner-section-category-next',
  },
     breakpoints: {
  1000: {
  	perPage: 3,
      gap:'10px',
  },
       800: {
  	perPage:2,
           gap:'5px',
  },
       450: {
  	perPage: 2,

  },
  },
    rewind: true,
    pagination:false,
  });

  festiveSlider.mount();

   var diamondSlider = new Splide('.custom-diamond-banner-section-categorys', {
      perPage: 4,
       autoplay:true,
      gap:'15px',
      arrows:true,
       classes: {
    arrows: 'splide__arrows custom-diamond-banner-section-category-arrow',
    arrow : 'splide__arrow custom-diamond-banner-section-category-arrow',
    prev  : 'splide__arrow--prev custom-diamond-banner-section-category-prev',
    next  : 'splide__arrow--next custom-diamond-banner-section-category-next',
    },
       breakpoints: {
    1000: {
    	perPage: 3,
      gap:'10px',
    },
         800: {
    	perPage:2,
           gap:'10px',
    },
         450: {
    	perPage: 2,
  gap:'5px',
    },
    },
      rewind: true,
      pagination:false,
    });

    diamondSlider.mount();

   var ocasionsSlider = new Splide('.shop-by-ocasions-ocasions', {
    perPage: 4,
     autoplay:true,
    gap:'10px',
    arrows:true,
     classes: {
  arrows: 'splide__arrows shop-by-categtory-arrow',
  arrow : 'splide__arrow shop-by-categtory-arrow',
  prev  : 'splide__arrow--prev shop-by-categtory-prev',
  next  : 'splide__arrow--next shop-by-categtory-next',
  },
     breakpoints: {
  1000: {
  	perPage: 3,
  },
       800: {
  	perPage:2,
  },
       450: {
  	perPage: 1,

  },
  },
    rewind: true,
    pagination:false,
  });

  ocasionsSlider.mount();
}
callForSlider();
 